<template>
  <div>
    <LargeSolidArchiveBoxArrowDown v-if="isActive('ArchiveBoxArrowDown', 'l', 'solid')" />
    <LargeSolidArrowDownTray v-if="isActive('ArrowDownTray', 'l', 'solid')" />
    <LargeSolidArrowLeft v-if="isActive('ArrowLeft', 'l', 'solid')" />
    <LargeSolidArrowPath v-if="isActive('ArrowPath', 'l', 'solid')" />
    <LargeSolidArrowRight v-if="isActive('ArrowRight', 'l', 'solid')" />
    <LargeSolidArrowRightOnRectangle v-if="isActive('ArrowRightOnRectangle', 'l', 'solid')" />
    <LargeSolidArrowTopRightOnSquare v-if="isActive('ArrowTopRightOnSquare', 'l', 'solid')" />
    <LargeSolidArrowUpTray v-if="isActive('ArrowUpTray', 'l', 'solid')" />
    <LargeSolidBeaker v-if="isActive('Beaker', 'l', 'solid')" />
    <LargeSolidBookOpen v-if="isActive('BookOpen', 'l', 'solid')" />
    <LargeSolidBolt v-if="isActive('Bolt', 'l', 'solid')" />
    <LargeSolidCalendar v-if="isActive('Calendar', 'l', 'solid')" />
    <LargeSolidCalendarDays v-if="isActive('CalendarDays', 'l', 'solid')" />
    <LargeSolidChartBar v-if="isActive('ChartBar', 'l', 'solid')" />
    <LargeSolidChatBubbleLeftEllipsis v-if="isActive('ChatBubbleLeftEllipsis', 'l', 'solid')" />
    <LargeSolidCheck v-if="isActive('Check', 'l', 'solid')" />
    <LargeSolidChevronDoubleRight v-else-if="isActive('ChevronDoubleRight', 'l', 'solid')" />
    <LargeSolidChevronDown v-else-if="isActive('ChevronDown', 'l', 'solid')" />
    <LargeSolidChevronLeft v-else-if="isActive('ChevronLeft', 'l', 'solid')" />
    <LargeSolidChevronRight v-else-if="isActive('ChevronRight', 'l', 'solid')" />
    <LargeSolidClock v-else-if="isActive('Clock', 'l', 'solid')" />
    <LargeSolidDocumentMagnifyingGlass v-else-if="isActive('DocumentMagnifyingGlass', 'l', 'solid')" />
    <LargeSolidDocumentPlus v-else-if="isActive('DocumentPlus', 'l', 'solid')" />
    <LargeSolidEllipsisVertical v-else-if="isActive('EllipsisVertical', 'l', 'solid')" />
    <LargeSolidEllipsisHorizontal v-else-if="isActive('EllipsisHorizontal', 'l', 'solid')" />
    <LargeSolidExclamationCircle v-else-if="isActive('ExclamationCircle', 'l', 'solid')" />
    <LargeSolidExclamationTriangle v-else-if="isActive('ExclamationTriangle', 'l', 'solid')" />
    <LargeSolidEye v-else-if="isActive('Eye', 'l', 'solid')" />
    <LargeSolidEyeSlash v-else-if="isActive('EyeSlash', 'l', 'solid')" />
    <LargeSolidFunnel v-else-if="isActive('Funnel', 'l', 'solid')" />
    <LargeSolidGlobeEuropeAfrica v-else-if="isActive('GlobeEuropeAfrica', 'l', 'solid')" />
    <LargeSolidHashtag v-else-if="isActive('Hashtag', 'l', 'solid')" />
    <LargeSolidHomeModern v-else-if="isActive('HomeModern', 'l', 'solid')" />
    <LargeSolidLightBulb v-else-if="isActive('LightBulb', 'l', 'solid')" />
    <LargeSolidMagnifyingGlass v-else-if="isActive('MagnifyingGlass', 'l', 'solid')" />
    <LargeSolidMinus v-else-if="isActive('Minus', 'l', 'solid')" />
    <LargeSolidNoSymbol v-else-if="isActive('NoSymbol', 'l', 'solid')" />
    <LargeSolidPlus v-else-if="isActive('Plus', 'l', 'solid')" />
    <LargeSolidTrash v-else-if="isActive('Trash', 'l', 'solid')" />
    <LargeSolidQuestionMarkCircle v-else-if="isActive('QuestionMarkCircle', 'l', 'solid')" />
    <LargeSolidXMark v-else-if="isActive('XMark', 'l', 'solid')" />

    <LargeOutlineArrowRightOnRectangle v-else-if="isActive('ArrowRightOnRectangle', 'l', 'outline')" />
    <LargeOutlineBolt v-else-if="isActive('Bolt', 'l', 'outline')" />
    <LargeOutlineDocumentDuplicate v-else-if="isActive('DocumentDuplicate', 'l', 'outline')" />
    <LargeOutlineExclamationCircle v-else-if="isActive('ExclamationCircle', 'l', 'outline')" />
    <LargeOutlineExclamationTriangle v-else-if="isActive('ExclamationTriangle', 'l', 'outline')" />
    <LargeOutlineGlobeEuropeAfrica v-else-if="isActive('GlobeEuropeAfrica', 'l', 'outline')" />
    <LargeOutlineLightBulb v-else-if="isActive('LightBulb', 'l', 'outline')" />
    <LargeOutlinePlus v-else-if="isActive('Plus', 'l', 'outline')" />
    <LargeOutlineQuestionMarkCircle v-else-if="isActive('QuestionMarkCircle', 'l', 'outline')" />
    <LargeOutlineTrash v-else-if="isActive('Trash', 'l', 'outline')" />
    <LargeOutlineXCircle v-else-if="isActive('XCircle', 'l', 'outline')" />
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  import * as largeSolid from '@heroicons/vue/24/solid'
  import * as largeOutline from '@heroicons/vue/24/outline'

  export default defineComponent({
    components: {
      LargeSolidArchiveBoxArrowDown: largeSolid.ArchiveBoxArrowDownIcon,
      LargeSolidArrowDownTray: largeSolid.ArrowDownTrayIcon,
      LargeSolidArrowLeft: largeSolid.ArrowLeftIcon,
      LargeSolidArrowPath: largeSolid.ArrowPathIcon,
      LargeSolidArrowRight: largeSolid.ArrowRightIcon,
      LargeSolidArrowRightOnRectangle: largeSolid.ArrowRightOnRectangleIcon,
      LargeSolidArrowTopRightOnSquare: largeSolid.ArrowTopRightOnSquareIcon,
      LargeSolidArrowUpTray: largeSolid.ArrowUpTrayIcon,
      LargeSolidBeaker: largeSolid.BeakerIcon,
      LargeSolidBookOpen: largeSolid.BookOpenIcon,
      LargeSolidBolt: largeSolid.BoltIcon,
      LargeSolidCalendar: largeSolid.CalendarIcon,
      LargeSolidCalendarDays: largeSolid.CalendarDaysIcon,
      LargeSolidChartBar: largeSolid.ChartBarIcon,
      LargeSolidChatBubbleLeftEllipsis: largeSolid.ChatBubbleLeftEllipsisIcon,
      LargeSolidCheck: largeSolid.CheckIcon,
      LargeSolidChevronDoubleRight: largeSolid.ChevronDoubleRightIcon,
      LargeSolidChevronDown: largeSolid.ChevronDownIcon,
      LargeSolidChevronLeft: largeSolid.ChevronLeftIcon,
      LargeSolidChevronRight: largeSolid.ChevronRightIcon,
      LargeSolidClock: largeSolid.ClockIcon,
      LargeSolidDocumentMagnifyingGlass: largeSolid.DocumentMagnifyingGlassIcon,
      LargeSolidDocumentPlus: largeSolid.DocumentPlusIcon,
      LargeSolidEllipsisVertical: largeSolid.EllipsisVerticalIcon,
      LargeSolidEllipsisHorizontal: largeSolid.EllipsisHorizontalIcon,
      LargeSolidExclamationCircle: largeSolid.ExclamationCircleIcon,
      LargeSolidExclamationTriangle: largeSolid.ExclamationTriangleIcon,
      LargeSolidEye: largeSolid.EyeIcon,
      LargeSolidEyeSlash: largeSolid.EyeSlashIcon,
      LargeSolidFunnel: largeSolid.FunnelIcon,
      LargeSolidGlobeEuropeAfrica: largeSolid.GlobeEuropeAfricaIcon,
      LargeSolidHashtag: largeSolid.HashtagIcon,
      LargeSolidHomeModern: largeSolid.HomeModernIcon,
      LargeSolidLightBulb: largeSolid.LightBulbIcon,
      LargeSolidMagnifyingGlass: largeSolid.MagnifyingGlassIcon,
      LargeSolidMinus: largeSolid.MinusIcon,
      LargeSolidNoSymbol: largeSolid.NoSymbolIcon,
      LargeSolidPlus: largeSolid.PlusIcon,
      LargeSolidTrash: largeSolid.TrashIcon,
      LargeSolidQuestionMarkCircle: largeSolid.QuestionMarkCircleIcon,
      LargeSolidXMark: largeSolid.XMarkIcon,

      LargeOutlineArrowRightOnRectangle: largeOutline.ArrowRightOnRectangleIcon,
      LargeOutlineBolt: largeOutline.BoltIcon,
      LargeOutlineDocumentDuplicate: largeOutline.DocumentDuplicateIcon,
      LargeOutlineExclamationCircle: largeOutline.ExclamationCircleIcon,
      LargeOutlineExclamationTriangle: largeOutline.ExclamationTriangleIcon,
      LargeOutlineGlobeEuropeAfrica: largeOutline.GlobeEuropeAfricaIcon,
      LargeOutlineLightBulb: largeOutline.LightBulbIcon,
      LargeOutlinePlus: largeOutline.PlusIcon,
      LargeOutlineQuestionMarkCircle: largeOutline.QuestionMarkCircleIcon,
      LargeOutlineTrash: largeOutline.TrashIcon,
      LargeOutlineXCircle: largeOutline.XCircleIcon,
    },
    props: {
      name: String,
      size: {
        type: String,
        default: 'l',
      },
      fill: {
        type: String,
        default: 'solid',
      },
    },
    methods: {
      isActive(name: string, size: string, fill: string): boolean {
        if (this.name != name) return false;
        if (this.size != size) return false;
        if (this.fill != fill) return false;
        return true;
      },
    },
  })
</script>
